import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
	token: null,
	site:null,
	info:null,
	battalionCommander:false
  },
  getters: {
  	// 用户是否登录
  	hasLogin: state => {
  		if (state.token) {
  			return true;
  		} else {
  			return false
  		}
  	},
  },
  mutations: {
	SET_TOKEN(state, token) {
		state.token = token;
		localStorage.token=token;
	},
	ChangeSite(state,site){
		state.site=site;
		localStorage.site=site;
	},
	SetInfo(state,info){
		state.info=info;
		localStorage.info=info;
	},
	SET_LOGOUT(state) {
		state.token = null;
		localStorage.removeItem("token");
		state.site =null;
		localStorage.removeItem("site");
		state.info =null;
		localStorage.removeItem("info");
		localStorage.removeItem('redirectUrl');
	}
	}
})
